import { render, staticRenderFns } from "./tick-circle.vue?vue&type=template&id=4b369e6d&"
import script from "./tick-circle.vue?vue&type=script&lang=js&"
export * from "./tick-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports